import _ from 'underscore';
import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Dropdown, Option } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const languageAll = 'All';

export function LanguageSelector(props) {
  const {
    languages,
    selectedLanguages,
    onSelectedLanguagesChanged,
    ariaLabel,
    multiSelect,
  } = props;

  const isSelectAll = useMemo(() => selectedLanguages.length === 1
  && selectedLanguages[0] === languageAll, [selectedLanguages]);

  const i18n = useContext(I18nContext);

  const options = _.map(languages, language => (
    {
      key: language.key,
      text: language.text,
      disabled: isSelectAll && language.key !== languageAll,
    }
  ));

  const value = useMemo(() => selectedLanguages.map(language => languages.find(option => option.key === language).text), [selectedLanguages, languages]);

  const dropdownStyles = { dropdown: { width: 320 } };

  return (
    <div className={classNames('language-selector-container')}>
      <Dropdown
        className="language-selector-dropdown"
        ariaLabel={ariaLabel}
        multiselect={multiSelect}
        placeholder={i18n.getString(_TL_('Choose a language'))}
        selectedOptions={selectedLanguages}
        onOptionSelect={onSelectedLanguagesChanged}
        styles={dropdownStyles}
        value={value}
      >
        {options.map(option => (
          <Option value={option.key} disabled={option.disabled} text={option.text}>
            {option.text}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
}

LanguageSelector.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string),
  selectedLanguages: PropTypes.arrayOf(PropTypes.string),
  onSelectedLanguagesChanged: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  multiSelect: PropTypes.bool,
};

LanguageSelector.defaultProps = {
  languages: [],
  selectedLanguages: [],
  ariaLabel: undefined,
  multiSelect: true,
};
